import { render, staticRenderFns } from "./CarisSelection.vue?vue&type=template&id=1727cc78&scoped=true&"
import script from "./CarisSelection.vue?vue&type=script&lang=js&"
export * from "./CarisSelection.vue?vue&type=script&lang=js&"
import style0 from "./CarisSelection.vue?vue&type=style&index=0&id=1727cc78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1727cc78",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fcaris-selection%2FCarisSelection.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports